import React from "react";
import { cn } from "@/lib/utils";
import { useTheme } from "@/context/ThemeContext";

/**
 * BrandLogo — Rikkus Bet
 * Reglas del Manual de Marca:
 *  - variant="principal"  → fondos claros (light mode / cards blancas)
 *  - variant="reverso"    → fondos oscuros / interfaz nocturna (dark mode)
 *  - variant="iso"        → sólo el isotipo R+caballo (< 180px de ancho)
 *  - variant="iso-white"  → isotipo blanco para dark backgrounds
 *  - variant="auto"       → elige principal/reverso según theme actual
 * Respeta el clear-space de 1X (altura de la barra R) vía `p-*` en el contenedor.
 */
export const BrandLogo = ({
    variant = "auto",
    className,
    imgClassName,
    alt = "Rikkus Bet",
    "data-testid": testid = "brand-logo",
}) => {
    const { theme } = useTheme();
    const resolved = variant === "auto" ? (theme === "dark" ? "reverso" : "principal") : variant;

    const src = {
        principal: "/brand/01_Logo_Principal_Transparente.png",
        reverso: "/brand/02_Logo_Reverso_Blanco_Teal.png",
        "mono-navy": "/brand/03_Logo_Monocromatico_Navy.png",
        "mono-blanco": "/brand/04_Logo_Monocromatico_Blanco.png",
        "mono-negro": "/brand/05_Logo_Monocromatico_Negro.png",
        iso: "/brand/06_Isotipo_R_Caballo.png",
        "iso-white": "/brand/07_Isotipo_R_Caballo_Blanco.png",
        bet: "/brand/08_Marca_Bet.png",
        icono: "/brand/09_Icono_App_1024.png",
    }[resolved] || "/brand/01_Logo_Principal_Transparente.png";

    return (
        <span
            data-testid={testid}
            data-variant={resolved}
            className={cn("inline-flex items-center", className)}
        >
            <img
                src={src}
                alt={alt}
                className={cn("block h-auto w-auto select-none pointer-events-none", imgClassName)}
                draggable={false}
            />
        </span>
    );
};

export default BrandLogo;
